import { createStyles, makeStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    linkButtons: {
      border: 'none',
      width: 288,
      backgroundColor: variables.white,
      fontSize: 16,
      fontWeight: 600,
      height: 56,
      textAlign: 'start',
      color: variables.richBlack,
      justifyContent: 'flex-start',
      verticalAlign: 'middle',
      '& .MuiButton-startIcon': {
        marginInlineStart: 6,
        marginInlineEnd: 18,

        '& .MuiSvgIcon-root': {
          fontSize: 17,
        },
      },

      '@media (hover: hover) and (pointer: fine)': {
        '&:hover': {
          backgroundColor: variables.white,
          color: variables.black50,
          '& .MuiButton-startIcon': {
            '& svg path': {
              stroke: variables.black50,
            },
          },
        },
      },
    },
  }),
);
